import React, { useState, useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { supabase } from "./supabase";
import { AtmosphericCountdown } from "./AtmosphericCountdown";
import { Admin } from "./Admin"; // Imports from Admin.tsx
import { AdminLogin } from "./AdminLogin";

export default function App() {
  const [session, setSession] = useState<any>(null);
  const [loginLoading, setLoginLoading] = useState(false);

  useEffect(() => {
    // Initial session check
    supabase.auth.getSession().then(({ data: { session } }: any) => {
      setSession(session);
    });

    // Listen for auth state changes (login/logout)
    const {
      data: { subscription },
    } = supabase.auth.onAuthStateChange((_event: any, session: any) => {
      setSession(session);
    });

    return () => subscription.unsubscribe();
  }, []);

  const handleLogin = async (
    e: React.FormEvent,
    emailInput: string,
    passInput: string
  ) => {
    e.preventDefault();
    setLoginLoading(true);

    const { error } = await supabase.auth.signInWithPassword({
      email: emailInput,
      password: passInput,
    });

    if (error) {
      alert("ACCESS DENIED: " + error.message);
    }

    setLoginLoading(false);
  };

  return (
    <BrowserRouter>
      <style>
        {`
          /* Ensure the app container handles mobile scaling correctly */
          html, body, #root {
            margin: 0;
            padding: 0;
            width: 100%;
            height: 100%;
            background-color: #050505;
          }

          @media (max-width: 768px) {
            /* Global mobile overrides for base elements if needed */
            input, button, select, textarea {
              font-size: 16px !important; /* Prevents iOS zoom on focus */
            }
          }
        `}
      </style>
      <Routes>
        {/* Public Landing Page */}
        <Route path="/" element={<AtmosphericCountdown />} />

        {/* Admin Route - Gated by Session */}
        <Route
          path="/admin"
          element={
            session ? (
              <Admin />
            ) : (
              <AdminLogin onLogin={handleLogin} loading={loginLoading} />
            )
          }
        />

        {/* Catch-all Redirect to Landing */}
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    </BrowserRouter>
  );
}
